import React, { Component } from "react";
import { TimerPlayer } from "@learningblocks/storybook-components";
import TRANSCRIPT_PATH from './sample.srt';
import animation from './centrifuge_spinning_animation.json';
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Toast from "../../../../Dialogs/toast/Toast";

// Styles
import { MicrocentrifugeNew } from "@learningblocks/storybook-components/lib/ProtocolComponents";


// const toasterNotify = (type, msg, title) => {
//   let color = "";
//   if (type === "HINT") {
//     color = colors.yellow1;
//   } else {
//     color = colors.red1;
//   }

//   toast(<Toast type={type} msg={msg} title={title} />, {
//     className: css({
//       border: "2px solid " + color,
//       borderRadius: "6px",
//       marginLeft: "-200px",
//       minWidth: "400px",
//       paddingLeft: 0
//     }),
//     progressClassName: css({
//       background: color
//     }),
//     position: "top-center",
//     autoClose: 5000
//   });
// };

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  },
  BALANCED: {
    title: "Balanced!",
    message: "Looks balanced."
  },
  NOT_BALANCED: {
    title: "Not balanced!",
    message: "Distribute the tubes evently to balance the centrifuge."
  },
  // WRONG_NUMBER_TUBES: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of tubes."
  // },
  // WRONG_NUMBER_ROTORS: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of rotors."
  // },
  NOT_ALLOWED_CENTRIFUGE_RUNNING: {
    title: "Centrifuge running!",
    message: "Operation not avaliable while centrifuge running."
  },
};

export class Graphics extends Component {


  constructor(props) {
    super(props)

    this.state = {
      frame: 0,
      isPaused: true,
      completed: false,
    }
  }

  animationData = {
    isPath: false,
    animation: animation,
  };

  onClickPause = () => {
    this.setState({ isPaused: true })
  };

  onClickPlay = () => {
    this.setState({ isPaused: false })
  };
  onPlaybackComplete = () => {
    console.log('running onPlaybackComplete');
    this.onClickPause();
    this.setState({ completed: true })
    this.props.animationPlaybackCompleteMC({ id: this.props.id })
  };

  setFrame = (frame) => {
    this.setState({ frame })
  }

  componentDidMount() {
    if (this.state.completed) {
      console.log('in component did mount because completed is true: ');
      this.props.animationPlaybackCompleteMC({ id: this.props.id })
      this.setState({ completed: false });
    }
  }

  checkBalance = () => {
    let tubesBalanced = this.centrifugeBalanced(this.props.slots);
    let rotorsBalanced = true;

    if (rotorsBalanced && tubesBalanced) {
      this.props.checkMicrocentrifugeBalance({
        id: this.props.id,
        balanced: true,
      });
      // toasterNotify("HINT", NOTIFY_EVENTS.BALANCED.message, NOTIFY_EVENTS.BALANCED.title);
      return true;
    }
  };

  centrifugeBalanced = (slots) => {

    let numberOfSlots = slots.length;
    let internalAngle = (360 / numberOfSlots); // Internal angle of a single slot

    let radius = 1; // Length from center (0,0) to a single slot (1,0)
    let balanceX = 0;
    let balanceY = 0

    slots.forEach((slot, i) => {
      if (slot.solution) {

        // Calculate the coordinate value for this slot (Math.sin / Math.cos require radians and not degrees)
        let oppositeSide = Math.sin((internalAngle * (i + 1)) * (Math.PI / 180)) * radius;
        let adjacentSide = Math.cos((internalAngle * (i + 1)) * (Math.PI / 180)) * radius;

        // Round the values to avoid floating point errors
        balanceX += +oppositeSide.toFixed(3);
        balanceY += +adjacentSide.toFixed(3);
      }
    })

    return (
      +balanceX.toFixed(3) === 0 &&
      +balanceY.toFixed(3) === 0
    );

  };

  render() {
    return (
      <MicrocentrifugeNew
        isLidOpen={this.props.lidOpen}
        isModalOpen={this.props.modalOpen}
        modalView={this.props.modalView}
        frontViewData={this.props.frontViewData}
        slots={this.props.slots}
        balanced={this.props.balanced}
        running={this.props.running}
        pulsing={this.props.pulsing}
        playbackComplete={this.props.completed}



        openModal={() => this.props.openModalMC({ id: this.props.id })}
        closeModal={() => this.props.closeModalMC({ id: this.props.id })}
        toggleLid={() => this.props.toggleLidMC({ id: this.props.id })}
        setModalView={(data) => this.props.setModalViewMC({ data, id: this.props.id })}
        setRPM={(data) => this.props.setRPMMC({ data, id: this.props.id })}
        setTimer={(data) => this.props.setTimerMC({ data, id: this.props.id })}
        onDropSlot={(data) => this.props.onDropSlotMC({ data, id: this.props.id })}
        onRunCentrifuge={(data) => this.props.onRunCentrifugeMC({ data, id: this.props.id })}
        onStopCentrifuge={(data) => this.props.onStopCentrifugeMC({ data, id: this.props.id })}
        onItemDropCentrifuge={(data) => this.props.onItemDropCentrifugeMC({ data, id: this.props.id })}
        removeSlotItems={(data) => {
          console.log('data');
          console.log('data');
          console.log(data);
          if (data === 'rotor') {
            this.props.slots.forEach((slot) => {

              if (slot.rotor) {
                this.props.setRotorAdaptersInScene({
                  id: slot.rotorId,
                  inScene: true,
                });

              }

            });
          } else {

            // We have to reindex the array to account for the slot positions
            let newSlotOrder = this.props.slots;
            newSlotOrder.push(newSlotOrder.shift());
            newSlotOrder.push(newSlotOrder.shift());

            newSlotOrder.forEach((slot) => {

              if (slot.solution) {
                this.props.setSolutionInScene({
                  id: slot.solutionId,
                  inScene: true,
                });
                console.log('slot: ', slot);
                if (slot.defaultProps && slot.defaultProps.originTubePosition && slot.defaultProps.originTubePosition.onIce) {
                  this.props.setSolutionOnIce({
                    id: slot.solutionId,
                    onIce: slot.defaultProps.originTubePosition.onIce,
                  });

                  this.props.setSolutionInScene({
                    id: slot.solutionId,
                    inScene: false,
                  });

                  this.props.addTubeToIceBucket({
                    id: slot.defaultProps.originTubePosition.onIce,
                    solutionId: slot.solutionId,
                    type: slot.defaultProps.type,
                  });

                  this.props.setSolutionOnRack({
                    id: slot.solutionId,
                    onRack: false,
                  })
                }
              }

            });
          }

          this.props.removeSlotItemsMC({ data, id: this.props.id })
        }}
        player={
          <TimerPlayer
            isPaused={this.state.isPaused}
            onClickPause={this.onClickPause}
            onClickPlay={this.onClickPlay}
            currentFrame={this.state.frame}
            onChangeFrame={this.setFrame}
            animationData={{
              isPath: false,
              animation: animation
            }
            }
            displayTime={this.props.frontViewData.settings.timerValue}
            disabled={!(this.props.running && !this.props.pulsing)}
            transcript={TRANSCRIPT_PATH}
            showTranscript={true}
            onComplete={this.onPlaybackComplete}
            tabIndex={'0'}
            lang={'en'}
          />
        }
      />


    );
  }
}
